export default class RootProductCategoryModel {
	constructor(data = {}) {
		this.id = data.id;
		this.name = data.name || null;
		this.code = data.code || null;
	}
}
